// eslint-disable-next-line
import React, { Fragment, useState, useEffect } from 'react';
import LoginHistoryAccordianItem from './LoginHistoryAccordianItem';

const LoginHistoryAccordian = props => {
	const { pageLanguageContent, profileId, data, loginHistoryData } = props;
	const [clicked, setClicked] = useState('0');
	const handleToggle = index => {
		if (clicked === index) {
			return setClicked('0');
		}

		setClicked(index);
	};

	return (
		<LoginHistoryAccordianItem
			onToggle={() => handleToggle('1')}
			active={clicked === '1'}
			key={'1'}
			currentIndex={'1'}
			pageLanguageContent={pageLanguageContent}
			profileId={profileId}
			data={data}
			loginHistoryData={loginHistoryData}
		/>
	);
};

export default LoginHistoryAccordian;